import type * as React from 'react'
import { isLightColor } from '../../helpers/colors'

interface TagCssProperties extends React.CSSProperties {
  '--tag-background-color': string
  '--tag-text-color': string
}

export const generateTagCssProperties = (color: string): TagCssProperties => {
  return {
    '--tag-background-color': color,
    '--tag-text-color': isLightColor(color)
      ? `color-mix(in srgb, ${color} 10%, black)`
      : `color-mix(in srgb, ${color} 10%, white)`,
  }
}
